import $ from 'jquery'
import * as lightSlider from 'lightslider';
import CmsDatepicker from "./modules/cms-datepicker";
// import CmsSelect2 from "./modules/cms-select2";
// import CaptchaInput from "./modules/cms-captcha";
// import SystemsightFormConditions from "./modules/cms-form-conditions";
// import "./modules/cms-maxlength";
import "./modules/old-browser-check"
import MapInstance from "../../Modules/Gis/assets/js/MapInstance"
import MapInstanceTeritory from "../../Modules/Gis/assets/js/MapInstanceTerritories"
import MapInstanceObjects from "../../Modules/Gis/assets/js/MapInstanceObjects"
import MapInstanceObjectBrands from "../../Modules/Gis/assets/js/MapInstanceObjectBrands"
import "./modules/leaflet-fullscreen.min.js";
global.$ = $;
global.jQuery = $;
window.$ = $;


//modal auto open


//a confirm
$('body').on('click', 'a[data-confirm],button[data-confirm]', function (e) {
    var r = confirm($(this).data("confirm"));
    if (r !== true) {
        e.preventDefault();
    }else{
        $(this).trigger('click-confirmed', e);
    }
});


$(".map-wrap").each(function (){
    MapInstance.init(this)
});

$(".map-territory").each(function (){
    MapInstanceTeritory.init(this)
});

$(".map-objects").each(function (){
    MapInstanceObjects.init(this)
});

$("#map_object_brands_block").each(function (){
    MapInstanceObjectBrands.init(this)
});

$(function() {
    $('#responsive').lightSlider({
        item:1,
        loop:false,
        slideMove:1,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:600,
        pager: false
    });
    $('.expand-head').click(function(){
        $(this).next('.expand-content').slideToggle();
        $(this).toggleClass('active');
    });

    $('#module_structure .text hr, #module_territories .text hr').each(function(){
        var parentElement = $(this).parent();
        var contentHtml = parentElement.html();
        var htmlarr = contentHtml.split('<hr>');
        if(htmlarr.length == 2)
        {
            var visibleText = '<div class="visible_text">'+htmlarr[0]+'</div>'
            var moreText = '<div class="more_text" style="display: none">'+htmlarr[1]+'</div>';
            parentElement.html(visibleText+moreText);
            parentElement.find('.visible_text').append('<p class="text-center"><a class="btn btn-outline-primary show_more" href="" title="">'+show_more_translation+'</a></p>');
            parentElement.find('.visible_text').append('<div class="bottom_fade"></div>');
            parentElement.find('.more_text').append('<p class="text-center"><a class="btn btn-outline-primary show_less" href="" title="">'+show_les_translation+'</a></p>');
        }
    });
    $('.show_more').on('click', function(e){
        e.preventDefault();
        $('.bottom_fade').hide();
        $(this).parent().parent().next('.more_text').slideToggle();
        $(this).hide();
    });
    $('.show_less').on('click', function(e){
        e.preventDefault();
        $(this).parent().parent().slideToggle();
        var moreButton = $(this).parent().parent().prev().find('.show_more');
        moreButton.show();
        $("html, body").animate({ scrollTop: (moreButton.offset().top-200)}, 1);
        $('.bottom_fade').show();
    });

    $('#nav-text').on('click', function(){
        $('#map').show();
        $('#map_object').hide();
        if (typeof(Event) === 'function') {
            // modern browsers
            window.dispatchEvent(new Event('resize'));
        } else {
            // for IE and other old browsers
            // causes deprecation warning on modern browsers
            var evt = window.document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        }
    });
    $('#nav-visitor').on('click', function(){
        $('#map').hide();
        $('#map_object').show();
        if (typeof(Event) === 'function') {
            // modern browsers
            window.dispatchEvent(new Event('resize'));
        } else {
            // for IE and other old browsers
            // causes deprecation warning on modern browsers
            var evt = window.document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        }
    });

    // disabilities version
    var jDisWrap = $('#disabilites_version');

    if(jDisWrap.length)
    {
        jDisWrap.on('click', 'a.dis_actions', function()
        {
            var value_key = $(this).data("key");
            var value = $(this).data("value");
            var pendingResize = false;
            var jBody = $('body');

            if(value_key == "size")
            {
                jBody.removeClass('size-1 size-2 size-3');
                $('#disabilites_version a.size').removeClass("active");
            }
            else if(value_key == "bg")
            {
                jBody.removeClass('bg-white bg-black');
                $('#disabilites_version a.bg').removeClass("active");
            }
            else if(value_key == "img")
            {
                jBody.removeClass('img-show img-hide');
                $('#disabilites_version a.img').removeClass("active");
                pendingResize = true;
            }
            $(this).addClass("active");
            jBody.addClass(value_key + '-' + value);
            $.get('/general/disabilities/action.' + value_key + '-' + value + '/');

            if(pendingResize)
            {
                $(window).trigger('resize');
            }
        });
    }
    //-----------------------------------------------------------
});
